import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/global/App';
import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import { HashRouter } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <HashRouter>
    <App />
  </HashRouter>
);
